export const hoverChange = () => {
  const hoverChangeEl = document.querySelector('.js-hover-change-image');
  if (!hoverChangeEl) return;
  const hoverChangeList = hoverChangeEl.querySelectorAll('.image-hover-item');
  const stageEl = hoverChangeEl.querySelector('.image-hover-stgage');
  hoverChangeList.forEach((item, index) => {
    item.addEventListener('mouseenter', () => {
      stageEl.querySelector('.active').classList.remove('active');
      stageEl.querySelector(`img:nth-child(${index + 1})`).classList.add('active');
    });
  });
}